import React, { useEffect, useState } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Form, Typography, Flex, Grid, Button, Drawer, Tooltip, Checkbox, DatePicker } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { useForm } from "antd/es/form/Form";
import dayjs from "dayjs";
import useMigrationDate from "../../../../hooks/useMigrationDate";
import InputField from "../../../../components/Input/Input";
import SearchAutoComplete from "../../../../components/SearchAutoComplete";
import StaticAutoComplete from "../../../../components/StaticAutoComplete";
import SalesReturnTable from "./salesReturnTable";
import {
  selectCustomersList,
  selectVouchersList,
  selectSalesReturnVoucher,
} from "../../salesReturnSelectors";
import {
  fetchCustomersList,
  fetchSalesVouchers,
  fetchSalesVoucherDetails,
  fetchSalesReturnAccounts,
  fetchSalesReturnWithDetails,
} from "../../salesReturnThunks";
import { resetVouchersList, setFormField } from "../../salesReturnSlice";
import {
  mapReturnItems,
  returnCalculateTotals as calculateReturnTotals,
} from "../../../../utils/sales_return";
import { accessChecker,currentDateTime, getAccessType, dateTimeFormat } from "../../../../lib/functions";
import store from "../../../../store";
import { selectAuthInfo } from "../../../Auth/authSelectors";

const { Title } = Typography;
const { useBreakpoint } = Grid;

const vatAndTaxOptions = [
  { label: "Total Item", value: "on_total" },
  { label: "Individual Item", value: "individual" },
];

const CreateSalesReturnForm = ({
  onSaveSalesReturn,
  salesReturnVoucher,
  selectedVoucherDetails,
  salesReturnAccs,
  salesTaxAccs,
  salesDiscountAccs,
  salesTransportAccs,

}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [form] = useForm();
  const screens = useBreakpoint();

  const { isEdit, selectedRecord, formData } = useSelector(
    (s) => s.salesReturn
  );
  const authInfo = useSelector(selectAuthInfo);

  const { sale_r_id: saleRIDFromURL } = useParams();

  const {
    taxMode,
    customer,
    selectedSaleInvoice,
    itemsList,
    selectedSalesReturnAcc,
    tags,
    footerValues,
    parent_sscc_code,
    is_tatmeen_product,
    created_date,
  } = useSelector((state) => state.salesReturn.formData);

  const { disabledDate } = useMigrationDate();

  const [updatedServices, setUpdatedServices] = useState([]);
  const [helpOpen, setHelpOpen] = useState(false);
  console.log(itemsList, "itemsLista");

  const currentFooterValues = useSelector(
    (state) => state.salesReturn.formData.footerValues
  );
  const selectedSerials = useSelector(
    (state) => state.salesReturn.selectedSerials
  );
  const salesVouchers = useSelector(selectVouchersList);
  // const salesReturnVoucherNo = useSelector(selectSalesReturnVoucher);
  const salesReturnVoucherNo = useSelector(
    (state) => state.salesReturn.formData.sale_r_voucher_no
  );
  let [access_type, access_type_set] = useState("");

  const showTatmeenColumn =
    authInfo?.is_tatmeen_enabled === "yes" &&
    authInfo?.country === "United Arab Emirates" && (authInfo?.subscription == 'PharmaERP_Pro' || authInfo?.subscription == 'PharmaERP_Standard' || authInfo?.subscription == 'PharmaERP_Basic');

  const hasTatmeenEntryAccess = accessChecker("tatmeen_entry");

  console.log(authInfo, showTatmeenColumn, hasTatmeenEntryAccess, "hasTatmeenEntryAccess");

  useEffect(() => {
    const access = getAccessType("sales_return");
    access_type_set(access);
  }, []);

  // useEffect(() => {
  //   const sale_r_id = saleRIDFromURL ? parseFloat(saleRIDFromURL) : 0;
  //   dispatch(setFormField({ field: "footerValues.sale_r_id", value: sale_r_id }));

  //   if (sale_r_id !== 0) {
  //     dispatch(setFormField({ field: "action", value: "update" }));
  //     dispatch(fetchSalesVoucherDetails(sale_r_id));
  //   } else {
  //     dispatch(setFormField({ field: "action", value: "create" }));
  //   }
  // }, [dispatch, saleRIDFromURL]);

  console.log(selectedVoucherDetails, "selectedVoucherDetails");


  useEffect(() => {
    if (saleRIDFromURL) {
      dispatch(fetchSalesReturnWithDetails(saleRIDFromURL));
    }
  }, [dispatch, saleRIDFromURL]);

  useEffect(() => {
    if (!tags.length) {
      dispatch(
        setFormField({
          field: "tags",
          value: [{ display_text: "Tag 1" }, { display_text: "Tag 2" }],
        })
      );
    }
  }, [tags, dispatch]);

  // useEffect(() => {
  //   if (isEdit) return;
  //   dispatch(fetchSalesReturnAccounts()).then((res) => {
  //     if (res?.payload) {
  //       const acc = res.payload;
  //       form.setFieldsValue({
  //         selectedSalesReturnAcc: acc.display_text || "",
  //       });
  //       form.validateFields(["selectedSalesReturnAcc"]);
  //       dispatch(
  //         setFormField({
  //           field: "selectedSalesReturnAcc",
  //           value: acc,
  //         })
  //       );
  //     }
  //   });
  // }, [dispatch, isEdit, form]);
  useEffect(() => {
    if (selectedSalesReturnAcc?.acc_id) {
      form.setFieldsValue({
        selectedSalesReturnAcc: selectedSalesReturnAcc.display_text || selectedSalesReturnAcc.acc_name,
      });
    }
  }, [selectedSalesReturnAcc, form]);
  useEffect(() => {
    if (!isEdit) return;

    form.setFieldsValue({
      search_customer: customer?.acc_name,
      selectedSaleInvoice: selectedSaleInvoice,
    });

  }, [isEdit, customer, selectedSaleInvoice, form]);

  useEffect(() => {
    if (!isEdit || !formData?.sale_id || !salesVouchers?.length) return;

    const realVoucher = salesVouchers.find(v => v.sale_id === formData.sale_id);

    if (realVoucher) {
      dispatch(setFormField({ field: "selectedSaleInvoice", value: realVoucher }));
    }
  }, [isEdit, formData?.sale_id, salesVouchers]);

  const handleCustomerSelect = (customer) => {
    if (customer === "add_new") {
      navigate(`/customers/addNewCustomer`, {
        state: { from: location.pathname },
      });
      return;
    }
    dispatch(setFormField({ field: "customer", value: customer }));

    // ✅ CLEAR invoice selection
    dispatch(setFormField({ field: "selectedSaleInvoice", value: null }));

    // ✅ CLEAR items table
    dispatch(setFormField({ field: "itemsList", value: [] }));
    dispatch(resetVouchersList());
    dispatch(fetchSalesVouchers(customer?.acc_id));
  };

  const handleSaleInvoiceSelect = (invoice) => {
    dispatch(setFormField({ field: "selectedSaleInvoice", value: invoice }));
    dispatch(fetchSalesVoucherDetails(invoice?.sale_id));
  };

  // useEffect(() => {
  //   console.log("selectedVoucherDetails", selectedVoucherDetails);

  //   if (
  //     selectedSaleInvoice?.sale_id &&
  //     selectedVoucherDetails?.salesDetails?.length
  //   ) {
  //     const selectedSale = selectedVoucherDetails.salesDetails.find(
  //       (sale) => sale.sale_id === selectedSaleInvoice?.sale_id
  //     );
  //     const match = selectedVoucherDetails.returnedItems.find(
  //       (sale) => sale.item_id === selectedSaleInvoice?.sale_id
  //     );

  //     if (selectedSale?.details?.length) {
  //       dispatch(
  //         setFormField({
  //           field: "itemsList",
  //           value: mapReturnItems(selectedSale.details),
  //         })
  //       );
  //     }
  //   }
  // }, [selectedVoucherDetails, selectedSaleInvoice, dispatch]);

  useEffect(() => {
    if (
      selectedSaleInvoice?.sale_id &&
      selectedVoucherDetails?.salesDetails?.length
    ) {
      const selectedSale = selectedVoucherDetails.salesDetails.find(
        (sale) => sale.sale_id === selectedSaleInvoice?.sale_id
      );

      // handleFooterChange(selectedSale.is_cal_type, "is_call_type");
      dispatch(

        setFormField({ field: "taxMode", value: selectedSale.is_cal_type })
      );

      const isTatmeen = selectedSale.is_tatmeen_product === 1 ||
        selectedSale.is_tatmeen_product === "1" ||
        selectedSale.is_tatmeen_product === true;

      dispatch(
        setFormField({
          field: "is_tatmeen_product",
          value: isTatmeen,
        })
      );

      if (selectedSale?.details?.length) {
        const totalItemCost = selectedSale?.details?.reduce(
          (sum, item) => sum + Number(item.item_total || 0),
          0
        );
        let otherServiceTransactions;
        const updatedItems = selectedSale.details.map((item) => {
          // Find if this item already has return history
          const match = selectedVoucherDetails.returnedItems?.find(
            (ret) => ret.item_id === item.item_id
          );
          // Calculate available quantity
          const soldQty = Number(item.sale_qty || item.item_qty || 0);
          const returnedQty = Number(match?.total_return_qty || 0);
          const availableQty = Math.max(soldQty - returnedQty, 0);

          // const totalItemCost = _.sumBy(selectedSale?.details, (item) =>
          //   Number(item.item_total)
          // );

          const itemTotal = Number(item.item_total);
          const itemQty = Number(item.item_qty);
          const itemShare = itemTotal / totalItemCost;

          otherServiceTransactions = selectedSale.otherServiceTrans.map(
            (service) => {
              const serviceAmount = Number(service.tran_amount);
              const itemServiceTotal = itemShare * serviceAmount;
              const perUnitService = itemServiceTotal / itemQty;

              return {
                to_acc_id: service.to_acc_id,
                service_name: service.to_acc_name,
                service_amount_total: itemServiceTotal.toFixed(2),
                service_amount_per_unit: perUnitService.toFixed(2),
              };
            }
          );

          return {
            ...item,
            available_qty: availableQty, // ✅ preserve computed value
            return_quantity: 0,
            otherServiceTransactions,
            selected_batch_id: item.batch_details_id || null,

            serial_mode: item.serial_mode || "unit",
            child_sscc_code: item.child_sscc_code || "",
            availableSerials: item.serials
              ? item.serials
                .split(",")
                .map((s) => s.trim())
                .filter(Boolean)
              : [],
            selectedSerials: [],
            // is_tatmeen_required: item.is_tatmeen_required === 1 ||
            //   item.is_tatmeen_required === "1" ||
            //   item.is_tatmeen_required === true,

            is_tatmeen_required: item.is_tatmeen_required ?? false,
          };
        });

        // 🧩 Keep computed available_qty even after mapping
        const mappedItems = mapReturnItems(updatedItems).map((itm, idx) => ({
          ...itm,
          available_qty:
            updatedItems[idx]?.available_qty ?? itm.available_qty ?? 0,
          otherServiceTransactions:
            updatedItems[idx]?.otherServiceTransactions ?? [],
          serial_mode: updatedItems[idx]?.serial_mode ?? itm.serial_mode,
          availableSerials: updatedItems[idx]?.availableSerials ?? [],
          selectedSerials: updatedItems[idx]?.selectedSerials ?? [],
          child_sscc_code:
            updatedItems[idx]?.child_sscc_code ?? "",
          is_tatmeen_required: updatedItems[idx]?.is_tatmeen_required ?? false,
        }));
        console.log(selectedSale, "selectedSale12");

        // handleFooterChange(
        //   selectedSale.otherServiceTrans,
        //   "otherServiceTransactions"
        // );
        dispatch(
          setFormField({
            field: "itemsList",
            value: mappedItems,
          })
        );

        dispatch(
          setFormField({
            field: "parent_sscc_code",
            value: selectedSale.sscc_code || "",
          })
        );

        dispatch(
          setFormField({
            field: "is_tatmeen_product",
            value: selectedSale.is_tatmeen_product === "yes",
          })
        );

      }
    }
  }, [selectedVoucherDetails, selectedSaleInvoice, dispatch]);

  // const handleInputChange = (value, key, field) => {
  //   const updated = itemsList.map((item) =>
  //     item.key === key ? { ...item, [field]: value } : item
  //   );
  //   dispatch(setFormField({ field: "itemsList", value: updated }));

  //   if (field === "return_quantity") {
  //     handleFooterChange(footerValues?.payCart || [], "payCart", updated);
  //   }
  // };

  const handleInputChange = (value, key, field) => {
    const updated = itemsList.map((item) => {
      if (item.key !== key) return item;

      const updatedItem = {
        ...item,
        [field]: value,
      };

      // Batch Mode
      if (updatedItem.serial_mode === "batch") {

        if (field === "return_quantity") {
          updatedItem.return_quantity =
            Number(value || 0) > 0
              ? Number(updatedItem.available_qty)
              : 0;
        }

      }

      return updatedItem;
    });

    dispatch(setFormField({ field: "itemsList", value: updated }));

    if (
      field === "return_quantity" ||
      field === "selectedSerials"
    ) {
      handleFooterChange(
        footerValues?.payCart || [],
        "payCart",
        updated
      );
    }
  };

  const handleItemChange = (key, changes) => {
    const updated = itemsList.map((item) => {
      if (item.key !== key) return item;

      return {
        ...item,
        ...changes,
      };
    });

    dispatch(
      setFormField({
        field: "itemsList",
        value: updated,
      })
    );
  };
  const handleFooterChange = (value, field, items = null) => {

    const currentItemsList = items || itemsList;

    // Create a new copy of footer state safely
    const updatedFooter = {
      ...footerValues,
      [field]: field === "payCart" ? [...value] : value,
    };

    // If updating payCart, recalc paidAmount automatically
    if (field === "payCart") {
      // const newPaidAmount = value?.reduce(
      //   (sum, item) => sum + parseFloat(item.tran_amount || item.amount || 0),
      //   0
      // );
      const newPaidAmount = value
        .filter((item) => item.acc_type_id !== "cheque") // 👈 exclude cheques
        .reduce((sum, item) => sum + parseFloat(item.tran_amount || 0), 0);

      updatedFooter.paidAmount = parseFloat(newPaidAmount.toFixed(2));
    }

    // Calculate totals
    const { dueAmount, grandTotal, totalSubtotal } = calculateReturnTotals(
      currentItemsList,
      updatedFooter
    );

    updatedFooter.subTotal = parseFloat(totalSubtotal.toFixed(2));
    updatedFooter.totalAmount = parseFloat(grandTotal.toFixed(2));
    updatedFooter.dueAmount = parseFloat(dueAmount.toFixed(2));
    dispatch(setFormField({ field: "footerValues", value: updatedFooter }));
  };

  const handleUpdatedServices = (services, key) => {
    // setUpdatedServices(...services);
    setUpdatedServices((prev) => ({
      ...prev,
      [key]: services,
    }));
  };


  const handleSubmit = () => {
    if (!customer || !selectedSaleInvoice) return;

    const extraMasterData = {
      sale_r_voucher_no: salesReturnVoucher,
      sale_id: selectedSaleInvoice?.sale_id,
      sales_return_acc_id: selectedSalesReturnAcc?.acc_id || 0,
      discount_acc_id: salesDiscountAccs[0]?.acc_id || 0,
      discount_acc_name: salesDiscountAccs[0]?.acc_name || "",
      tax_acc_id: salesTaxAccs[0]?.acc_id || 0,
      tax_acc_name: salesTaxAccs[0]?.acc_name || "",
      transport_acc_id: footerValues?.transport_acc_id || 0,
      is_cal_type: taxMode,
      created_date: created_date || null,
      narration: footerValues?.narration || "",
      orderId: footerValues?.orderId || 0,
      sale_r_id: footerValues?.sale_r_id || 0,
      parent_sscc_code,
      is_tatmeen_product,
    };

    onSaveSalesReturn(
      customer,
      itemsList,
      footerValues,
      extraMasterData,
      selectedSerials,
      updatedServices
    );
  };

  useEffect(() => {
    dispatch(fetchCustomersList(""));
  }, [dispatch]);

  useEffect(() => {
    if (isEdit && selectedRecord) {
      const { header, items } = selectedRecord;

      dispatch(setFormField({ field: "customer", value: header.customer }));
      dispatch(
        setFormField({
          field: "selectedSaleInvoice",
          value: header.selectedSaleInvoice,
        })
      );
      dispatch(setFormField({ field: "itemsList", value: items }));
      dispatch(
        setFormField({
          field: "selectedSalesReturnAcc",
          value: header.salesReturnAcc,
        })
      );
      dispatch(setFormField({ field: "taxMode", value: header.taxMode }));
      dispatch(setFormField({ field: "tags", value: header.tags }));
      dispatch(
        setFormField({ field: "footerValues", value: header.footerValues })
      );
    }
  }, [isEdit, selectedRecord, dispatch]);

  return (
    <div className="sales-return-form">
      <Flex justify="space-between" align="center">
        <Title level={3}>
          Sales Return
        </Title>

        <Tooltip title="Help">
          <Button
            type="text"
            icon={<QuestionCircleOutlined style={{ fontSize: 18 }} />}
            onClick={() => setHelpOpen(true)}
          />
        </Tooltip>
      </Flex>

      <Form
        form={form}
        layout="horizontal"
        style={{ width: "100%", maxWidth: "1200px" }}
        colon={false}
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 18 }}
        onFinish={handleSubmit}
      >
        {/* Buttons */}
        {!screens.xs && (
          <Flex gap={16} style={{ marginBottom: "24px" }}>
            <Button
              size="large"
              className="traic-button"
              onClick={() => navigate("/sales-dashboard")}
            >
              Back
            </Button>
            {access_type == "WRITE" && (
              <>
                <Button
                  type="primary"
                  size="large"
                  className="traic-button"
                  onClick={handleSubmit}
                >
                  Save
                </Button>
              </>
            )}
          </Flex>
        )}

        {/* Form Two Columns */}
        <Flex
          gap={!screens.md || !screens.xl ? 10 : 80}
          justify="center"
          style={{
            flexDirection: !screens.md || !screens.xl ? "column" : "row",
            width: "100%",
            marginBottom: "24px",
          }}
        >
          {/* Left Column */}
          <Flex
            vertical
            gap={10}
            style={{ width: !screens.md || !screens.xl ? "100%" : "40%" }}
          >
            <Form.Item
              label="Search Customer"
              name="search_customer"
              rules={[{ required: true, message: "Customer is required" }]}
            >
              <SearchAutoComplete
                showAddNew={false}
                placeholder="Customer"
                searchThunk={(text) => dispatch(fetchCustomersList(text))}
                resultSelector={selectCustomersList}
                // onSelect={handleCustomerSelect}
                onSelect={(value) => {
                  // ✅ Update AntD form field so validation clears
                  form.setFieldsValue({
                    search_customer: value?.acc_name,
                    selectedSaleInvoice: null,
                  });
                  form.validateFields(["search_customer"]);

                  // ✅ Continue your Redux logic
                  handleCustomerSelect(value);
                }}
              />
            </Form.Item>

            <Form.Item label="Institution Name">
              <InputField value={customer?.institution_name} disabled />
            </Form.Item>

            <Form.Item label="Customer Address">
              <InputField value={customer?.address} disabled />
            </Form.Item>

            <Form.Item
              label="Sales Return Account"
              name="selectedSalesReturnAcc"
              rules={[{ required: true, message: "Sales Return Account is required" }]}
            >
              <StaticAutoComplete
                optionsList={salesReturnAccs}
                onSelect={(acc) => {
                  form.setFieldsValue({
                    selectedSalesReturnAcc: acc.display_text || "",
                  });
                  form.validateFields(["selectedSalesReturnAcc"]);
                  dispatch(setFormField({ field: "selectedSalesReturnAcc", value: acc }));
                }}
                placeholder="Select a sales return account"
                disabled={!salesReturnAccs?.length}
                value={selectedSalesReturnAcc}
              />
            </Form.Item>
            {/* <Form.Item label="Tag" name="tag">
              <SearchAutoComplete
                searchThunk={(text) => {
                  const filtered = tags.filter((tag) =>
                    tag.display_text.toLowerCase().includes(text.toLowerCase())
                  );
                  dispatch(setFormField({ field: "tags", value: filtered }));
                }}
                resultSelector={() => tags}
                onSelect={(tag) =>
                  dispatch(setFormField({ field: "selectedItem", value: tag }))
                }
                placeholder="Tag"
              />
            </Form.Item> */}
          </Flex>

          {/* Right Column */}
          <Flex
            vertical
            gap={10}
            style={{ width: !screens.md || !screens.xl ? "100%" : "40%" }}
          >
            <Form.Item
              label="Sale Invoice"
              name="selectedSaleInvoice"
              // rules={[{ required: true, message: "Invoice is required" }]}
              rules={[
                {
                  required: true,
                  validator: (_, value) =>
                    value && typeof value === "object" && value.sale_id
                      ? Promise.resolve()
                      : Promise.reject(new Error("Invoice is required")),
                },
              ]}
            >
              <StaticAutoComplete
                optionsList={salesVouchers}
                // value={form.getFieldValue("selectedSaleInvoice")}
                // onSelect={handleSaleInvoiceSelect}
                onSelect={(invoice) => {
                  // ✅ Set value inside AntD Form so validation clears
                  form.setFieldsValue({ selectedSaleInvoice: invoice });
                  form.validateFields(["selectedSaleInvoice"]);

                  // ✅ Continue your redux logic
                  handleSaleInvoiceSelect(invoice);
                }}
                placeholder="Sale Invoice"
                disabled={!salesVouchers?.length}
                value={selectedSaleInvoice}
              />
            </Form.Item>

            <Form.Item label="Entry Date" rules={[{ required: true, message: "Please select date" }]}>
              <DatePicker
                style={{ width: "100%" }}
                value={created_date ? dayjs(created_date) : null}
                onChange={(d) =>
                  dispatch(setFormField({ field: "created_date", value: d ? d.toISOString() : null }))
                }
                disabledDate={disabledDate}
                format={dateTimeFormat}
              />
            </Form.Item>

            <Form.Item label="Contact No">
              <InputField value={customer?.contact_no} disabled />
            </Form.Item>

            <Form.Item label="Voucher No">
              <InputField value={salesReturnVoucherNo || ""} disabled />
            </Form.Item>

            {hasTatmeenEntryAccess && showTatmeenColumn && (
              <Form.Item label="Parent SSCC Code">
                <InputField
                  value={parent_sscc_code}
                  onChange={(e) =>
                    dispatch(
                      setFormField({
                        field: "parent_sscc_code",
                        value: e.target.value,
                      })
                    )
                  }
                />
              </Form.Item>
            )}

            {hasTatmeenEntryAccess && showTatmeenColumn && (
              <Form.Item label="Tatmeen Product">
                <Checkbox
                  checked={is_tatmeen_product}
                  disabled={isEdit}
                  onChange={(e) =>
                    dispatch(
                      setFormField({
                        field: "is_tatmeen_product",
                        value: e.target.checked,
                      })
                    )
                  }
                >
                  Is Tatmeen Product
                </Checkbox>
              </Form.Item>
            )}

          </Flex>
        </Flex>

        {/* VAT / Discount */}
        {/* <Flex justify="center" style={{ width: !screens.md || !screens.xl ? "100%" : "50%", marginBottom: "24px" }}> */}
        {/* <Form.Item label="Discount"> */}
        {/* <Radio.Group */}
        {/* options={vatAndTaxOptions}
              onChange={(e) => dispatch(setFormField({ field: "taxMode", value: e.target.value }))}
               value={taxMode}
             /> */}
        {/* </Form.Item> */}
        {/* </Flex> */}

        {/* Tag Search */}
        {/* <Flex justify="center" style={{ width: "50%", marginBottom: "24px" }}>

          <Form.Item label="Tag" name="tag">
            <div>
              <SearchAutoComplete
                searchThunk={(text) => {
                  const filtered = tags.filter(tag =>
                    tag.display_text.toLowerCase().includes(text.toLowerCase())
                  );
                  dispatch(setFormField({ field: "tags", value: filtered }));
                }}
                resultSelector={() => tags}
                onSelect={(tag) => dispatch(setFormField({ field: "selectedItem", value: tag }))}
                placeholder="Tag"
              />
            </div>
          </Form.Item>
        </Flex> */}
      </Form>

      {/* Table */}
      <div style={{ width: "100%", maxWidth: "1300px" }}>
        <SalesReturnTable
          itemsList={itemsList}
          handleInputChange={handleInputChange}
          handleFooterChange={handleFooterChange}
          footerValues={footerValues}
          taxMode={taxMode}
          openSerialModal={(item) =>
            console.log("open modal for serials", item)
          }
          onUpdateServices={handleUpdatedServices}
          authInfo={authInfo}
           handleItemChange={handleItemChange}
        />
      </div>

      {/* Bottom Buttons */}
      <Flex gap={16} style={{ marginTop: "32px", marginBottom: "32px" }}>
        <Button
          size="large"
          className="traic-button"
          onClick={() => navigate("/sales-dashboard")}
        >
          Back
        </Button>
        {access_type == "WRITE" && (
          <>
            <Button
              type="primary"
              size="large"
              className="traic-button"
              onClick={handleSubmit}
            >
              Save
            </Button>
          </>
        )}
      </Flex>
      <Drawer
        title="Sales Return Help"
        open={helpOpen}
        onClose={() => setHelpOpen(false)}
        width={420}
        styles={{
          wrapper: {
            paddingTop: !screens.md ? "80px" : undefined
          }
        }}
      >
        <div style={{ lineHeight: 1.8 }}>
          <h2
            style={{
              fontSize: "18px",
              fontWeight: 600,
              marginBottom: "12px",
              marginLeft: "8px",
            }}
          >
            Sales Return
          </h2>

          <p
            style={{
              color: "#555",
              marginBottom: "16px",
              marginLeft: "8px",
            }}
          >
            The Sales Return page is used to record returned items from
            completed sales invoices. It helps update inventory, customer
            accounts, and financial records accurately within the ERP system.
          </p>

          <div
            style={{
              background: "#f5f5f5",
              padding: "14px",
              borderRadius: "8px",
              marginBottom: "16px",
            }}
          >
            <strong>Steps to Create Sales Return</strong>

            <ol style={{ paddingLeft: "20px", marginTop: "10px" }}>
              <li>Open <strong>Sales → Sales Return</strong></li>
              <li>Select the customer</li>
              <li>Choose the related sales invoice</li>
              <li>Verify invoice and customer details</li>
              <li>Enter return quantity for items</li>
              <li>Review taxes, discounts, and totals</li>
              <li>Verify return account details</li>
              <li>Click <strong>Save</strong> to complete the sales return</li>
            </ol>
          </div>

          <div
            style={{
              background: "#fafafa",
              border: "1px solid #eee",
              padding: "14px",
              borderRadius: "8px",
            }}
          >
            <strong>Important Notes</strong>

            <ul
              style={{
                paddingLeft: "18px",
                marginTop: "10px",
                color: "#666",
              }}
            >
              <li>A valid sales invoice is required for processing returns.</li>
              <li>Returned quantity cannot exceed sold quantity.</li>
              <li>Inventory stock updates automatically after saving.</li>
              <li>Verify return quantities carefully before submission.</li>
            </ul>
          </div>
        </div>
      </Drawer>
    </div>
  );
};

export default CreateSalesReturnForm;
